import { render, staticRenderFns } from "./relatedContacts.vue?vue&type=template&id=181166f7&lang=pug"
import script from "./relatedContacts.vue?vue&type=script&lang=js"
export * from "./relatedContacts.vue?vue&type=script&lang=js"
import style0 from "./relatedContacts.vue?vue&type=style&index=0&id=181166f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports